import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {WIZARD_ROUTES} from '../../pages/wizard/wizard-routes';

@Component({
  selector: 'assessment-text-link',
  templateUrl: './assessment-text-link.component.html'
})
export class AssessmentTextLinkComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  onRetry(): void {
    this.router.navigate([WIZARD_ROUTES.UPLOAD_PAGE]).then(/* DO NOTHING */);
  }
}
